<template>
  <div class="card">
    <div class="card-header">
      <h4>{{ $t('sms.self') }}</h4>
    </div>
    <div class="card-body">
      <a-button
        class="mb-3"
        type="link"
        icon="plus"
        @click="showFormModal()"
      >
        {{ $t('common.add') }}
      </a-button>
      <a-table
        row-key="hashId"
        :loading="loading"
        :data-source="tasks"
        :columns="columns"
        :pagination="false"
        bordered
        responsive
      >
        <template
          slot="phone"
          slot-scope="text"
        >
          {{ text | phoneFormatter }}
        </template>
        <template
          slot="actions"
          slot-scope="id, row"
        >
          <div class="d-flex justify-content-around">
            <a-button
              class="mr-2 mb-2"
              icon="edit"
              variant="light"
              @click="showFormModal(row)"
            />
            <a-popconfirm
              :title="$t('common.are_you_sure')"
              :ok-text="$t('common.delete')"
              :cancel-text="$t('common.cancel')"
              @confirm="handleDelete(row)"
            >
              <a-icon
                slot="icon"
                type="question-circle-o"
                style="color: red"
              />
              <a-button
                icon="delete"
              />
            </a-popconfirm>
          </div>
        </template>
      </a-table>
      <a-modal
        :title="form.id ? $t('sms.edit') : $t('sms.add_new')"
        :visible="formModalVisible"
        :footer="null"
        :width="800"
        @cancel="formModalVisible = false"
      >
        <a-form-model
          ref="sms-form"
          :rules="rules"
          :model="form"
          v-bind="layout"
        >
          <a-form-model-item
            :label="$t('sms.phone')"
            prop="phone"
            has-feedback
          >
            <the-mask
              v-model="form.phone"
              class="ant-input"
              mask="+998 ## ### ## ##"
              placeholder="+998 ##-###-####"
            />
          </a-form-model-item>
          <a-form-model-item
            :label="$t('sms.name')"
            prop="name"
            has-feedback
          >
            <a-input
              v-model="form.name"
            />
          </a-form-model-item>
          <a-form-model-item
            :label="$t('sms.comment')"
            prop="name"
            has-feedback
          >
            <a-textarea
              v-model="form.comment"
              :auto-size="{ minRows: 2, maxRows: 5 }"
            />
          </a-form-model-item>
          <a-form-model-item
            :wrapper-col="{span: 24, offset: 20}"
          >
            <a-button
              :loading="loading"
              type="primary"
              @click="handleSave('sms-form')"
            >
              {{ form.hashId ? $t('common.save') : $t('auction.create') }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </div>
</template>

<script>
import SMS_Service from '@/services/api/admin/library/sms-schedule-service'

export default {
  name: 'SMSSchedule',
  data () {
    return {
      loading: false,
      tasks: [],
      formModalVisible: false,
      form: {
        hashId: null,
        phone: null,
        name: null,
        comment: null,
      },
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      columns: [
        {
          title: this.$t('sms.name'),
          dataIndex: 'name',
        },
        {
          title: this.$t('sms.phone'),
          dataIndex: 'phone',
          scopedSlots: { customRender: 'phone' },
        },
        {
          title: this.$t('sms.comment'),
          dataIndex: 'comment',
        },
        {
          dataIndex: 'hashId',
          width: '150px',
          scopedSlots: {
            customRender: 'actions',
          },
        },
      ],
    }
  },

  computed: {
    rules() {
      return {
        name: [{
          validator: this.validateNull,
          trigger: 'change',
        }],
        phone: [{
          validator: this.validateNull,
          trigger: 'change',
        }],
        comment: [{
          validator: this.validateNull,
          trigger: 'change',
        }],
      }
    },
  },

  async mounted() {
    await this.getTasks()
  },

  methods: {
    validateNull(rule, value, callback) {
      if (value === null) {
        callback(new Error(this.$t('common.required')))
      } else {
        callback()
      }
    },
    async getTasks() {
      this.loading = true
      try {
        const { data: { content } } = await SMS_Service.getTasks()
        this.tasks = content
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    showFormModal(row) {
      this.formModalVisible = true
      if (row) {
        this.form = {
          hashId: row.hashId,
          phone: row.phone,
          name: row.name,
          comment: row.comment,
        }
      } else {
        this.form = {
          hashId: null,
          phone: null,
          name: null,
          comment: null,
        }
      }
    },

    handleSave(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const payload = { ...this.form, phone: `998${this.form.phone}` }
          try {
            if (this.form.hashId) {
              payload.recommended = true
              await SMS_Service.updateTask(this.form.hashId, payload)
            } else {
              await SMS_Service.createTask(payload)
            }
            await this.getTasks()
            this.formModalVisible = false
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },

    handleCompanySelect(company) {
      this.company = company
    },

    async handleDelete(row) {
      this.loading = true
      try {
        await SMS_Service.deleteTask(row.hashId)
        this.getTasks()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
